import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { applyPrefs } from './lib/preferences';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';

// Lazy-load heavier routes so the homepage stays light.
const Blog        = lazy(() => import('./components/Blog'));
const BlogPost    = lazy(() => import('./components/BlogPost'));
const Photos      = lazy(() => import('./components/Photos'));
const Skills      = lazy(() => import('./components/Skills'));
const SkillDetail = lazy(() => import('./components/SkillDetail'));

const Fallback = () => (
  <div className="loading-state" style={{ padding: '4rem 1.5rem', textAlign: 'center' }}>
    Loading…
  </div>
);

// Redirect legacy /admin paths to the standalone admin SPA.
const AdminRedirect = ({ path = '' }) => {
  useEffect(() => {
    window.location.replace(`https://admin.parthmerchant.com${path}`);
  }, [path]);
  return null;
};

function AppContent() {
  useEffect(() => { applyPrefs(); }, []);

  return (
    <div className="site">
      <Header />
      <main className="main">
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/skills/:slug" element={<SkillDetail />} />
            <Route path="/admin" element={<AdminRedirect />} />
            <Route path="/admin/*" element={<AdminRedirect />} />
            <Route path="/settings" element={<AdminRedirect path="/dashboard?tab=settings" />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
